import { Renderer } from '@unseenco/taxi'
import { isDEVMODE, viewStorage, domStorage } from '../_globals'

export default class Single extends Renderer {

  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {}

    this.init()
  }

  init() {}

  onLeaveCompleted() {}
}
